module.exports = __webpack_public_path__ + "img/TBWTTNL_about-the-story.764de88f.png";